import { render, staticRenderFns } from "./authPasswordExpiredSuccess.vue?vue&type=template&id=2dc15abc&scoped=true"
import script from "./authPasswordExpiredSuccess.vue?vue&type=script&lang=js"
export * from "./authPasswordExpiredSuccess.vue?vue&type=script&lang=js"
import style0 from "./authPasswordExpiredSuccess.vue?vue&type=style&index=0&id=2dc15abc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dc15abc",
  null
  
)

export default component.exports